module.exports = __webpack_public_path__ + "static/media/SolutionPage_Bg@2x.acc4da21.png";